





























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_municipalitySelections_currentUnit_municipalitySelections } from '@/queries/__generated__/municipalitySelections';

@Component
export default class MunicipalityShow extends Vue {
  @Prop() private municipalitySelection!: GQL_municipalitySelections_currentUnit_municipalitySelections;
  private get addresses(): string {
    return [
      this.municipalitySelection.municipality.address1,
      this.municipalitySelection.municipality.address2,
      this.municipalitySelection.municipality.address3,
    ]
      .filter(m => m)
      .join(', ');
  }
}
